import React from 'react'
import { useFormContext } from 'react-hook-form'
import { useNavigate } from 'react-router'

import { compile } from '~/apps/ninesegsAnalyzer/routes/paths'
import {
  IconButton,
  type IconButtonProps,
} from '~/components/elements/IconButton'
import { useLogEvent } from '~/hooks/useLogEvent'

import { useArchiveDocumentReportMutation } from '../hooks/useArchiveDocumentReportMutation'
import { useBrandAccountId } from '../hooks/useBrandAccountId'
import { type InputValues } from '../utils'

export const DocumentReportArchiveButton = () => {
  const { reset } = useFormContext<InputValues>()
  const navigate = useNavigate()
  const brandAccountId = useBrandAccountId()
  const logEvent = useLogEvent()
  const archiveDocumentReportMutation = useArchiveDocumentReportMutation({
    onSuccess: () => {
      reset()
      navigate(compile('documentReportList', { brandAccountId }))
      logEvent('Delete document')
    },
  })

  const handleClick = React.useCallback<EH<IconButtonProps, 'onClick'>>(() => {
    archiveDocumentReportMutation.mutate()
  }, [archiveDocumentReportMutation])

  return (
    <IconButton
      disabled={archiveDocumentReportMutation.isPending}
      fillMode="outline"
      icon="delete"
      onClick={handleClick}
    />
  )
}
